import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { SingleColorType, StepCounterType } from '../types';

import { colors } from '../constants';

import { setBackgroundColor } from '../redux/actions/backgroundColor';
import { nextStep, previousStep } from '../redux/actions/step';

import { OutroView } from '../components/OutroView';

interface IProps {
    stepDisplayNumber: number;
    headerText: string;
    totalSteps: number;
    setBackgroundColorConnect(color: SingleColorType): void;
    onNextStep(): void;
    onPreviousStep(stepCounter: StepCounterType): void;
    onCloseButtonClick?(): void;
}

export const BaseOutro: React.FC<IProps> = ({
    stepDisplayNumber,
    headerText,
    totalSteps,
    setBackgroundColorConnect,
    onNextStep,
    onPreviousStep,
    onCloseButtonClick,
}) => {
    useEffect(() => {
        setBackgroundColorConnect(colors.greenBg);
    });

    return (
        <OutroView
            totalSteps={totalSteps}
            onAnimationExit={onNextStep}
            stepNumber={stepDisplayNumber}
            onBackButtonClick={() => onPreviousStep('main')}
            onCloseButtonClick={onCloseButtonClick}
            headerText={headerText}
        />
    );
};

const mapDispatchToProps = {
    setBackgroundColorConnect: setBackgroundColor,
    onNextStep: nextStep,
    onPreviousStep: previousStep,
};

export const Outro = connect(
    null,
    mapDispatchToProps
)(BaseOutro);
